"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNICODE_NORMALIZATION_FORMS = void 0;
const UNICODE_NORMALIZATION_FORMS = exports.UNICODE_NORMALIZATION_FORMS = ['NFD', 'NFC', 'NFKD', 'NFKC'];